import {
  formatCustomerAddress,
  pickCustomerPhone,
  type CustomerAddress,
} from "@/api/endpoints/address";

export function ContractCard({
  address,
  selected,
  onSelect,
}: {
  address: CustomerAddress;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onSelect}
      className={`w-full rounded-xl border-2 px-[17px] pt-[10px] pb-3 text-left ${
        selected ? "border-primary" : "border-field-label"
      }`}
    >
      <span className="flex items-baseline justify-between gap-4">
        <span className="text-16 text-field-label leading-6 font-medium">
          เลขที่สัญญา :
        </span>
        <span className="text-16 text-field-value leading-6 font-medium">
          {address.accountNo}
        </span>
      </span>

      <hr className="mt-[14px] border-t border-divider-strong" />

      <span className="text-16 text-field-label mt-[11px] block leading-6 font-medium">
        ที่อยู่
      </span>
      <span className="text-16 text-field-value block leading-[22.6px] font-medium">
        {formatCustomerAddress(address)}
      </span>

      <span className="mt-[5px] flex items-baseline gap-[7px]">
        <span className="text-16 text-field-label leading-6 font-medium">
          เบอร์โทรจัดส่งเอกสาร
        </span>
        <span className="text-16 text-field-value leading-6 font-medium">
          {pickCustomerPhone(address)}
        </span>
      </span>
    </button>
  );
}
